/**
 * slick
 */
let slick = () => {
  $('#visual-slick').slick({
    arrows: false,
    autoplay: true,
    autoplaySpeed: 8000,
    infinite: true,
    fade: true,
    pauseOnFocus: false,
    pauseOnHover: false,
    speed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
  });

  $('#js-visual-news__ticker').slick({
    accessibility: false,
    arrows: false,
    dots: false,
    autoplay: true,
    autoplaySpeed: 4000,
    centerMode: true,
    centerPadding: '0',
    infinite: true,
    pauseOnFocus: false,
    pauseOnHover: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  });

  const slick = $('.js-slick');
  $(slick).each(function (index, element) {
    const target = $(element).find('.js-slick__target');
    const show = target.attr('data-show') ? target.data('show') : '3';
    const showsp = target.attr('data-showsp') ? target.data('showsp') : '1';
    target.slick({
      accessibility: false,
      adaptiveHeight: true, // 高さ可変
      arrows: true,
      dots: false,
      autoplay: true,
      autoplaySpeed: 4000,
      centerMode: true,
      centerPadding: '30px',
      infinite: true,
      pauseOnFocus: false,
      pauseOnHover: false,
      speed: 500,
      slidesToShow: show,
      slidesToScroll: 1,
      prevArrow: '<span class="c-slick-photo__prev"><i class="fas fa-angle-left"></i></span>',
      nextArrow: '<span class="c-slick-photo__next"><i class="fas fa-angle-right"></i></span>',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            centerMode: false,
            centerPadding: 0,
            slidesToShow: showsp,
          },
        },
      ],
    });
  });

  const slider = $('.js-slider');
  $(slider).each(function (index, element) {
    const target = $(element).find('.js-slider__target');
    const thum = $(element).find('.js-slider__thum');
    target.slick({
      accessibility: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      asNavFor: '.c-slider__thum', //サムネイルのクラス名
    });
    thum.slick({
      accessibility: false,
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: '.c-slider__main', //スライダー本体のクラス名
      focusOnSelect: true,
      prevArrow:
        '<span class="c-slider__arrow c-slider__prev"><i class="fas fa-angle-left"></i></span>',
      nextArrow:
        '<span class="c-slider__arrow c-slider__next"><i class="fas fa-angle-right"></i></span>',
    });
  });

  const service = $('.js-slick-service');
  $(service).each(function (index, element) {
    const target = $(element).find('.js-slick__target');
    const show = target.attr('data-show') ? target.data('show') : '3';
    const showsp = target.attr('data-showsp') ? target.data('showsp') : '1';
    target.slick({
      accessibility: false,
      adaptiveHeight: true, // 高さ可変
      arrows: true,
      dots: false,
      autoplay: true,
      autoplaySpeed: 4000,
      centerMode: true,
      centerPadding: 0,
      infinite: true,
      pauseOnFocus: false,
      pauseOnHover: false,
      speed: 500,
      slidesToShow: show,
      slidesToScroll: 1,
      touchThreshold: 10,
      waitForAnimate: false,
      lazyLoad: 'ondemand',
      prevArrow: '<span class="c-slick-photo__prev"><i class="fas fa-angle-left"></i></span>',
      nextArrow: '<span class="c-slick-photo__next"><i class="fas fa-angle-right"></i></span>',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            //centerMode: false,
            //centerPadding: 0,
            slidesToShow: showsp,
          },
        },
      ],
    });
  });

  const news = $('.js-slick-news');
  $(news).each(function (index, element) {
    const target = $(element).find('.js-slick__target');
    const show = target.attr('data-show') ? target.data('show') : '3';
    const showsp = target.attr('data-showsp') ? target.data('showsp') : '1';
    target.slick({
      accessibility: false,
      adaptiveHeight: true, // 高さ可変
      arrows: false,
      dots: false,
      autoplay: true,
      autoplaySpeed: 4000,
      centerMode: true,
      centerPadding: '0',
      infinite: true,
      pauseOnFocus: false,
      pauseOnHover: false,
      speed: 500,
      slidesToShow: show,
      slidesToScroll: 1,
      touchThreshold: 10,
      waitForAnimate: false,
      lazyLoad: 'ondemand',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            //centerMode: false,
            //centerPadding: 0,
            slidesToShow: showsp,
          },
        },
      ],
    });
  });
};

/**
 * 初期化
 */
let init = () => {
  slick();
};

export default { init, slick };
